/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const es_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const de_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const nl_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const fr_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const it_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const pt_br2_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const pt_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const ja_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

const zh_uc_summary = /** @type {(inputs: { value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} ${i?.from} = ${i?.result} ${i?.to}`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ value: NonNullable<unknown>, from: NonNullable<unknown>, result: NonNullable<unknown>, to: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_summary = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_summary(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_summary", locale)
	if (locale === "en") return en_uc_summary(inputs)
	if (locale === "es") return es_uc_summary(inputs)
	if (locale === "de") return de_uc_summary(inputs)
	if (locale === "nl") return nl_uc_summary(inputs)
	if (locale === "fr") return fr_uc_summary(inputs)
	if (locale === "it") return it_uc_summary(inputs)
	if (locale === "pt-BR") return pt_br2_uc_summary(inputs)
	if (locale === "pt") return pt_uc_summary(inputs)
	if (locale === "ja") return ja_uc_summary(inputs)
	return zh_uc_summary(inputs)
};